import React, {Component} from "react";
import {Settings} from "../Utils/Settings.js";
import InputLabel from "@material-ui/core/InputLabel";
import {Input} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";


class FinancingCalculator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: {
                downPayment: Settings.financeCalculatorDefaultPayment,
                numberOfYears: Settings.financeCalculatorDefaultYears,
                interestRate: Settings.financeCalculatorDefaultInterestRatePercent,
                loanAmount: this.props.loanAmount,

                calculatedTotalAmount: "",
                calculatedMonthlyPayment: "",

            },
            enabled: this.props.enabled,
        };
        this.calculateAndSetResults(this.state);
    }

    onInputChange(evt, target) {
        const value = evt.target.value;
        this.setState(state => {
           state.details[target] = value;
           this.calculateAndSetResults(state);
           return state;
        });
    }

    calculateAndSetResults(state) {
        var calculatedTotal = (state.details.loanAmount * (1- (this.state.details.downPayment/100)));
        var calculatedInterestRate = (state.details.interestRate / 1200);
        var calculatedNumberOfMonths = state.details.numberOfYears * 12;
        var calculatedMonthlyAmount = ((calculatedTotal * calculatedInterestRate) /
            (1 - Math.pow(1 + calculatedInterestRate, calculatedNumberOfMonths * -1)));

        if (isNaN(calculatedTotal) || isNaN(calculatedMonthlyAmount)) {
            state.details.calculatedTotalAmount = "Invalid";
            state.details.calculatedMonthlyPayment = "";
        } else {
            state.details.calculatedTotalAmount = "$" + Number.parseFloat(calculatedTotal).toFixed(2);
            state.details.calculatedMonthlyPayment = "$" + Number.parseFloat(calculatedMonthlyAmount).toFixed(2);
        }
    }

    render() {
        if (!this.props.enabled) {
            return <React.Fragment></React.Fragment>;
        }
        const css = `
            .financing-wrapper-outer {
                margin-top: 18px;
                border-top: 1px solid #000;
            }
            .financing-field-wrapper { 
                margin-bottom: 12px;
            }
            .financing-heading {
                font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                font-size: 22px;
                font-weight: bold;
            }
            .financing-subheading {
                font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                font-size: 18px;
                font-weight: bold;
            }
        `;

        return (
            <div className="financing-wrapper-outer">
                <style>{css}</style>
                <div className="financing-wrapper-inner">
                    <h2 className="financing-heading">{Settings.financeCalculatorHeader}</h2>
                    <form onSubmit={(e) => this.onSubmitHandle(e)}>
                        <div className="financing-controls">
                            <div className="financing-field-wrapper">
                                <InputLabel>Loan Amount</InputLabel>
                                <TextField type="number" id="financing-amount"
                                           onChange={(e) => this.onInputChange(e, "loanAmount")}
                                           value={this.state.details.loanAmount}></TextField>
                            </div>
                            <div className="financing-field-wrapper">
                                <InputLabel>Down Payment %</InputLabel>
                                <TextField type="number" min="0" max="99" id="financing-downpayment"
                                           onChange={(e) => this.onInputChange(e, "downPayment")}
                                           value={this.state.details.downPayment}></TextField>
                            </div>
                            <div className="financing-field-wrapper">
                                <InputLabel>Interest Rate %</InputLabel>
                                <TextField type="number" min="0" max="99" id="financing-interestRate"
                                           onChange={(e) => this.onInputChange(e, "interestRate")}
                                           value={this.state.details.interestRate}></TextField>
                            </div>
                            <div className="financing-field-wrapper">
                                <InputLabel>Loan Term (Years)</InputLabel>
                                <TextField type="number" min="0" max="30" id="financing-terms"
                                           onChange={(e) => this.onInputChange(e, "numberOfYears")}
                                           value={this.state.details.numberOfYears}></TextField>
                            </div>
                            <h2 className="financing-subheading">{Settings.financeCalculatorSubheader}</h2>
                            <div className="financing-field-wrapper">
                                <InputLabel>Total Loan Amount:</InputLabel>
                                <TextField type="text" id="financing-totalAmount"
                                           value={this.state.details.calculatedTotalAmount}></TextField>
                            </div>
                            <div className="financing-field-wrapper">
                                <InputLabel>Monthly Payment:</InputLabel>
                                <TextField type="text" id="financing-monthlypayment"
                                           value={this.state.details.calculatedMonthlyPayment}></TextField>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default (FinancingCalculator);
